















































































export default
  props: ['game']

  metaInfo:
    title: 'Fat Hooks :: redka.games'
